(function () {
  const scriptConfig = document.currentScript ? document.currentScript.dataset : {};
  const config = Object.assign({}, scriptConfig, window.ysSubscriptionFreeGiftGuard || {});

  if (!(config.enabled === true || config.enabled === 'true')) return;

  const variantIds = toSet(config.variantIds, normalizeId);
  const productIds = toSet(config.productIds, normalizeId);
  const handles = toSet(config.handles, normalizeHandle);

  if (!variantIds.size && !productIds.size && !handles.size) return;

  const events = [
    'cart:updated',
    'cart:refresh',
    'ajaxProduct:added',
    'ajaxProduct:removed',
    'quantity:updated',
    'drawer:opened'
  ];

  let timer = null;
  let busy = false;
  let queued = false;
  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Eigene Korrekturen lösen keine weitere Prüfung über den Fetch-Beobachter aus.
  const cartFetch = window.fetch.bind(window);

  function normalizeId(value) {
    return String(value || '').trim();
  }

  function normalizeHandle(value) {
    let handle = String(value || '').trim().toLowerCase();

    if (!handle) return '';

    handle = handle.replace(/^https?:\/\/[^/]+/, '');
    handle = handle.replace(/^\/+/, '');

    const productsPathIndex = handle.indexOf('/products/');
    if (productsPathIndex !== -1) {
      handle = handle.slice(productsPathIndex + '/products/'.length);
    }

    if (handle.indexOf('products/') === 0) {
      handle = handle.slice('products/'.length);
    }

    return handle.split(/[/?#]/)[0];
  }

  function tokenize(value) {
    if (Array.isArray(value)) return value;

    return String(value || '').split(/[\s,;|]+/);
  }

  function toSet(value, normalizer) {
    return new Set(
      tokenize(value)
        .map(normalizer)
        .filter(Boolean)
    );
  }

  function getCartItemHandle(item) {
    return normalizeHandle(item.handle || item.url || '');
  }

  function isConfiguredGift(item) {
    return (
      variantIds.has(String(item.variant_id || item.id || '')) ||
      productIds.has(String(item.product_id || '')) ||
      handles.has(getCartItemHandle(item))
    );
  }

  function hasSubscriptionMarker(item) {
    if (item.selling_plan_allocation || item.selling_plan) return true;

    const properties = item.properties;
    if (!properties || typeof properties !== 'object') return false;

    return Object.keys(properties).some(function (key) {
      const value = properties[key];
      const normalizedKey = String(key || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
      const hasValue = value !== null && value !== undefined && value !== '' && value !== false;

      if (!hasValue) return false;

      return [
        'selling_plan',
        '_selling_plan',
        'selling_plan_id',
        '_selling_plan_id',
        'shipping_interval_frequency',
        '_shipping_interval_frequency',
        'shipping_interval_unit_type',
        '_shipping_interval_unit_type'
      ].indexOf(normalizedKey) !== -1;
    });
  }

  function getCartItemVariantIdFromElement(item) {
    const itemKey = item && item.dataset ? String(item.dataset.id || '') : '';
    return itemKey.split(':')[0] || '';
  }

  function getCartItemHandleFromElement(item) {
    if (!item || !item.querySelector) return '';

    const link = item.querySelector('a[href*="/products/"]');
    return normalizeHandle(link ? link.getAttribute('href') : '');
  }

  function isConfiguredGiftElement(item) {
    if (!item || !item.dataset) return false;

    const variantId = getCartItemVariantIdFromElement(item);
    const productId = String(item.dataset.productId || '');
    const handle = getCartItemHandleFromElement(item);

    return (
      (variantId && variantIds.has(variantId)) ||
      (productId && productIds.has(productId)) ||
      (handle && handles.has(handle))
    );
  }

  function isQuantityLockedGiftElement(item) {
    if (isConfiguredGiftElement(item)) return true;
    if (!item || !item.dataset) return false;

    const handle = getCartItemHandleFromElement(item);
    const title = String(item.dataset.title || '').trim().toLowerCase();

    return (
      handle.indexOf('docapp-free-gift') === 0 ||
      title.indexOf('geschenk:') === 0 ||
      title.indexOf('cadeau') === 0
    );
  }

  function lockQuantityControls(item, isLocked) {
    if (!item) return;

    item.classList.toggle('cart-item--subscription-free-gift', Boolean(isLocked));
    item.dataset.subscriptionFreeGift = isLocked ? 'true' : 'false';

    item.querySelectorAll('.qty-minus, .qty-plus').forEach(function (button) {
      button.hidden = Boolean(isLocked);
      button.setAttribute('aria-hidden', isLocked ? 'true' : 'false');
      if (isLocked) {
        button.setAttribute('tabindex', '-1');
      } else {
        button.removeAttribute('tabindex');
      }
    });

    const quantityInput = item.querySelector('.qty');
    if (!quantityInput) return;

    if (isLocked) {
      quantityInput.setAttribute('readonly', 'readonly');
      quantityInput.setAttribute('aria-readonly', 'true');
      quantityInput.dataset.subscriptionFreeGiftLocked = 'true';
    } else if (quantityInput.dataset.subscriptionFreeGiftLocked === 'true') {
      quantityInput.removeAttribute('readonly');
      quantityInput.removeAttribute('aria-readonly');
      delete quantityInput.dataset.subscriptionFreeGiftLocked;
    }
  }

  function applyQuantityControlLocks() {
    document.querySelectorAll('[data-js-cart-item]').forEach(function (item) {
      lockQuantityControls(item, isQuantityLockedGiftElement(item));
    });
  }

  function domHasConfiguredGift() {
    const cartItems = document.querySelectorAll('[data-js-cart-item]');

    if (!cartItems.length) return false;

    return Array.from(cartItems).some(function (item) {
      return isConfiguredGiftElement(item);
    });
  }

  function cartHasConfiguredGift(cart) {
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some(isConfiguredGift));
  }

  function responseHasConfiguredGift(data) {
    if (!data || typeof data !== 'object') return false;

    if (Array.isArray(data.items)) {
      return data.items.some(isConfiguredGift);
    }

    return isConfiguredGift(data);
  }

  function getMutationTypeFromUrl(input) {
    let url = '';

    if (typeof input === 'string') {
      url = input;
    } else if (input && typeof input.url === 'string') {
      url = input.url;
    }

    if (!url) return '';

    if (url.indexOf('/cart/add.js') !== -1) return 'add';
    if (url.indexOf('/cart/change.js') !== -1) return 'change';
    if (url.indexOf('/cart/update.js') !== -1) return 'update';
    if (url.indexOf('/cart/clear.js') !== -1) return 'clear';

    return '';
  }

  function handleCartMutationResponse(type, data) {
    if (!type || !responseHasConfiguredGift(data)) return;

    if (type === 'add') {
      scheduleCheck(0, null, true);
      return;
    }

    scheduleCheck(0, data);
  }

  function observeCartFetches() {
    if (typeof window.fetch !== 'function' || window.fetch.ysSubscriptionFreeGiftGuardObserved) return;

    const originalFetch = window.fetch;

    window.fetch = function () {
      const mutationType = getMutationTypeFromUrl(arguments[0]);

      return originalFetch.apply(this, arguments).then(function (response) {
        if (mutationType && response && response.ok) {
          response.clone().json().then(function (data) {
            handleCartMutationResponse(mutationType, data);
          }).catch(function () {});
        }

        return response;
      });
    };

    window.fetch.ysSubscriptionFreeGiftGuardObserved = true;
  }

  function observeCartXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.ysSubscriptionFreeGiftGuardObserved) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.ysSubscriptionFreeGiftGuardMutationType = getMutationTypeFromUrl(url);
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this.ysSubscriptionFreeGiftGuardMutationType) {
        this.addEventListener('loadend', function () {
          if (this.status < 200 || this.status >= 300 || !this.responseText) return;

          try {
            handleCartMutationResponse(
              this.ysSubscriptionFreeGiftGuardMutationType,
              JSON.parse(this.responseText)
            );
          } catch (error) {}
        });
      }

      return originalSend.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.ysSubscriptionFreeGiftGuardObserved = true;
  }

  async function getCart() {
    const response = await cartFetch(cartRoot + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) throw new Error('Cart request failed');

    return await response.json();
  }

  async function changeGiftQuantity(item, quantity) {
    // Nur die eindeutig identifizierte Geschenkzeile ändern. Positionen können
    // sich durch gleichzeitige Änderungen anderer Warenkorb-Skripte verschieben.
    if (!isConfiguredGift(item) || !item.key) throw new Error('Gift line key missing');
    const payload = { id: item.key, quantity: quantity };

    const response = await cartFetch(cartRoot + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) throw new Error('Cart change request failed');

    return await response.json();
  }

  function getGiftCorrection(cart) {
    const items = cart.items || [];
    const giftItems = items.filter(isConfiguredGift);
    if (!giftItems.length) return null;

    const hasSubscription = items.some(function (item) {
      return !isConfiguredGift(item) && hasSubscriptionMarker(item);
    });

    if (!hasSubscription) return { item: giftItems[0], quantity: 0 };

    // Eine bestehende Zeile mit Lieferinformationen behalten. Ihre Eigenschaften
    // und ihr Selling Plan werden durch die reine Mengenänderung nicht ersetzt.
    const giftToKeep = giftItems.find(function (item) {
      return item.properties && item.properties._ZapietId;
    }) || giftItems[0];

    if (giftToKeep.quantity > 1) return { item: giftToKeep, quantity: 1 };

    const extraGift = giftItems.find(function (item) { return item !== giftToKeep; });
    return extraGift ? { item: extraGift, quantity: 0 } : null;
  }

  function getGiftQuantity(cart) {
    return (cart.items || []).filter(isConfiguredGift).reduce(function (quantity, item) {
      return quantity + item.quantity;
    }, 0);
  }

  async function refreshCartUi() {
    const detail = { source: 'ys-subscription-free-gift-guard' };

    document.dispatchEvent(new CustomEvent('ys:subscription-free-gift-removed', { detail }));

    if (window.location.pathname.replace(/\/+$/, '') === cartRoot + 'cart') {
      window.location.reload();
      return;
    }

    if (typeof window.refreshCart === 'function') {
      try {
        await window.refreshCart();
      } catch (error) {}
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
  }

  async function checkCart(cartFromEvent, forceFetch) {
    if (busy) {
      queued = true;
      return;
    }

    if (!forceFetch && !cartHasConfiguredGift(cartFromEvent) && !domHasConfiguredGift()) return;

    busy = true;
    let changed = false;

    try {
      // Ereignisse können veraltete Warenkörbe enthalten. Vor jeder Korrekturrunde
      // den aktuellen Stand laden und danach jeweils Shopifys Antwort verwenden.
      let cart = await getCart();
      let correction = getGiftCorrection(cart);

      while (correction) {
        const previousQuantity = getGiftQuantity(cart);
        cart = await changeGiftQuantity(correction.item, correction.quantity);
        changed = true;
        if (getGiftQuantity(cart) >= previousQuantity) {
          throw new Error('Gift quantity did not decrease');
        }
        correction = getGiftCorrection(cart);
      }
    } catch (error) {
      console.warn('Subscription free gift guard failed:', error);
    } finally {
      if (changed) await refreshCartUi();
      busy = false;

      if (queued) {
        queued = false;
        scheduleCheck(80, null, true);
      }
    }
  }

  function scheduleCheck(delay, cartFromEvent, forceFetch) {
    applyQuantityControlLocks();

    if (!forceFetch && !cartHasConfiguredGift(cartFromEvent) && !domHasConfiguredGift()) return;

    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      checkCart(cartFromEvent, forceFetch);
    }, typeof delay === 'number' ? delay : 80);
  }

  events.forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      const detail = event && event.detail ? event.detail : {};

      applyQuantityControlLocks();

      if (detail.source === 'ys-subscription-free-gift-guard') return;

      scheduleCheck(eventName === 'cart:updated' ? 0 : 80, detail.cart);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyQuantityControlLocks();
      scheduleCheck(80);
    });
  } else {
    applyQuantityControlLocks();
    scheduleCheck(80);
  }

  observeCartFetches();
  observeCartXhr();

  window.setInterval(function () {
    if (!document.hidden && domHasConfiguredGift()) scheduleCheck(80);
  }, 5000);
})();
